var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order-card border-b-8 border-neutral-100 last:border-b-0"
  }, [_c('div', {
    staticClass: "px-4 py-4 flex justify-between items-center gap-6 shadow-border-b mdmax:px-4 mdmax:py-4"
  }, [_c('div', {
    staticClass: "flex gap-3 mdmax:items-start mdmax:gap-1 mdmax:flex-col justify-between items-center"
  }, [_c('span', [_c('span', {
    staticClass: "inline-flex px-2 py-1 text-xs rounded-md mdmax:flex-shrink-0 text-center",
    class: _vm.statusClass
  }, [_vm._v(_vm._s(_vm.data.status))])]), _c('div', [_c('span', {
    staticClass: "text-neutral-700 font-medium mdmax:text-sm block text-xs mb-1"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.data.created_at)))]), _c('span', {
    staticClass: "text-neutral-500 mdmax:text-sm block text-xs mb-1"
  }, [_c('span', {
    staticClass: "text-neutral-700 font-medium"
  }, [_vm._v("Nomor pesanan:")]), _vm._v(" " + _vm._s(_vm.data.order_id) + " ")]), _c('p', {
    staticClass: "text-neutral-500 text-xs flex items-center gap-2 mdmax:flex-col mdmax:gap-1 mdmax:items-start"
  }, [_c('span', [_c('span', {
    staticClass: "text-neutral-700 font-medium"
  }, [_vm._v("Borzo Tracking:")]), _c('a', {
    staticClass: "text-blue-500 underline",
    attrs: {
      "href": _vm.data.borzo_tracking_url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.data.borzo_order_id))])])])])]), _vm.isMobile ? _c('span', {
    staticClass: "inline-block cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.expand();
      }
    }
  }, [_c('Chevron', {
    attrs: {
      "direction": "down"
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "flex justify-between flex-wrap items-start shadow-border-b text-neutral-500 mdmax:flex-col mdmax:shadow-none",
    class: {
      hidden: !_vm.visibleContent && _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "w-2/5 border-r p-4 mdmax:w-full mdmax:p-4 mdmax:border-none mdmax:shadow-border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-start gap-6 mdmax:gap-2"
  }, [_c('div', {
    staticClass: "w-2/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(" Nama Pengirim ")]), _c('p', {
    staticClass: "font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden",
    attrs: {
      "title": _vm.data.sender_name
    }
  }, [_vm._v(" " + _vm._s(_vm.data.sender_name) + " ")]), _c('p', {
    staticClass: "text-neutral-400 text-sm"
  }, [_vm._v(_vm._s(_vm.data.sender_phone))])]), _c('div', {
    staticClass: "w-3/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(" Alamat Pengirim ")]), _c('p', {
    staticClass: "ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto"
  }, [_vm._v(" " + _vm._s(_vm.data.sender_address) + " ")])])]), _c('div', {
    staticClass: "mt-4 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Detail Alamat")]), _c('p', [_vm._v(_vm._s(_vm.data.sender_detail_address || "-"))])])]), _c('div', {
    staticClass: "w-2/5 border-r p-4 mdmax:border-none mdmax:p-4 mdmax:w-full mdmax:shadow-border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-start gap-6 mdmax:gap-2"
  }, [_c('div', {
    staticClass: "w-2/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700 whitespace-nowrap"
  }, [_vm._v(" Nama Penerima ")]), _c('p', {
    staticClass: "font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden",
    attrs: {
      "title": _vm.data.receiver_name
    }
  }, [_vm._v(" " + _vm._s(_vm.data.receiver_name) + " ")]), _c('p', {
    staticClass: "text-neutral-400 text-sm"
  }, [_vm._v(_vm._s(_vm.data.receiver_phone))])]), _c('div', {
    staticClass: "w-3/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(" Alamat Penerima ")]), _c('p', {
    staticClass: "ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto"
  }, [_vm._v(" " + _vm._s(_vm.data.receiver_address) + " ")])])]), _c('div', {
    staticClass: "mt-4 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(" Detail Alamat ")]), _c('p', [_vm._v(_vm._s(_vm.data.receiver_detail_address || "-"))])])]), _c('div', {
    staticClass: "w-1/5 p-4 mdmax:w-full mdmax:shadow-border-b"
  }, [_c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Barang")]), _c('p', [_vm._v(_vm._s(_vm.data.item_description))])]), _c('div', {}, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Nilai Barang")]), _c('p', [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.data.item_value || 0)))])])]), _c('div', {
    staticClass: "w-full p-4 border-t mdmax:border-none mdmax:shadow-border-b"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-2 text-neutral-700"
  }, [_vm._v("Rincian Pembayaran")]), _c('div', {
    staticClass: "flex flex-wrap gap-x-8 gap-y-2 text-sm"
  }, [_c('div', [_c('p', {
    staticClass: "text-neutral-500 mb-1"
  }, [_vm._v("Biaya Asuransi")]), _c('p', {
    staticClass: "font-medium text-neutral-700"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.data.insurance_fee_amount || 0)))])]), _c('div', [_c('p', {
    staticClass: "text-neutral-700 font-bold mb-1"
  }, [_vm._v("Total Pembayaran")]), _c('p', {
    staticClass: "font-bold text-neutral-700"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.data.payment_amount || 0)))])])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }